import { Component, Input, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { take, finalize } from 'rxjs';
import { PageSizeService } from 'src/app/modules/services/page-size/page-size.service';
import { RelatoriosContratuaisService } from 'src/app/modules/services/relatorios-contratuais/relatorios-contratuais.service';
import { ToastService } from 'src/app/modules/services/toast/toast.service';

import { PageEvent } from '@angular/material/paginator';

import { MatDialog } from '@angular/material/dialog';
import { FormRelatorioComponent } from 'src/app/modules/shared/modals/form-relatorio/form-relatorio.component';
import { ModalController } from '@ionic/angular';
import { AlertComponent } from 'src/app/modules/components/alert/alert.component';
import { LoadingService } from 'src/app/modules/components/loading/loading.service';
import { ModalComponent } from 'src/app/modules/components/modal/modal.component';
import { ModalDeleteLotesComponent } from 'src/app/modules/shared/modals/modal-delete-lotes/modal-delete-lotes.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ModalFiltersComponent } from 'src/app/modules/shared/modals/modal-filters/modal-filters.component';
import { ModalHistoricComponent } from 'src/app/modules/shared/modals/modal-historic/modal-historic.component';

@Component({
  selector: 'app-relatorios-contratuais',
  templateUrl: './relatorios-contratuais.component.html',
  styleUrls: ['./relatorios-contratuais.component.scss']
})
export class RelatoriosContratuaisComponent implements OnInit {
  @Input() cnpj: any;
  @Input() buttonInclusaoDisabled: boolean = false;
  @Input() buttonExclusaoDisabled: boolean = false;
  @Input() buttonEdicaoDisabled: boolean = false;
  screenWidth: number = 0;
  screenHeight: number = 0;
  actionDeleteLotes:string = '';
  @Input() contractId: any;
  // === TABELA: Documentos Assinados ===
  sortState = {
    sortProperty: 'criadoEm',
    sortDirection: 'desc'
  };

columnConfig = [
  { columnDef: 'checkbox', header: 'checkbox', property: 'checkbox', custom: true },
  { columnDef: 'tipo', header: 'Tipo', property: 'tipoRelatorio.nome' },
  { columnDef: 'areaResponsavel', header: 'Área Responsável', property: 'areaFuncional.nome' },
  { columnDef: 'relatorio', header: 'Relatório', property: 'relatorio.nome', customTd: true },
  { columnDef: 'itemContratual', header: 'Item Contratual', property: 'itemContratual' },
  { columnDef: 'periodoReferencia', header: 'Período de Referência', property: 'periodoReferenciaInicio', customTd: true },
  { columnDef: 'prazo', header: 'Prazo', property: 'prazo', customTd: true },
  { columnDef: 'actions', header: 'Ações', custom: true }
];

  dataSource = new MatTableDataSource<any>();
  displayedColumns: string[] = [];
  pageIndex = 0;
  pageSize = 10;
  totalPages = 1;
  totalElements = 0;
   dataAction:any;
  idRelatorio: any;
  criterios: any = [];
  criteriosLabels!: { [key: string]: string; };
  formRelatorioContratual!: FormGroup;
  filterData:any;
  filterText:string = "";
  // === CONSTRUTOR ===
  constructor(
    private relatoriosContratuaisService: RelatoriosContratuaisService,
    private _snackBar: MatSnackBar,
    private loadingService: LoadingService,
    private pageSizeService: PageSizeService,
    public dialog: MatDialog,
    private fb: FormBuilder,
    private modalCtrl: ModalController,
  ) { }
  ngOnInit(): void {
    this.displayedColumns = this.columnConfig.map(col => col.columnDef);
    this.getData(this.contractId);
     this.formRelatorioContratual = this.fb.group({
      nomeRelatorio: [''],
      nomeAreaFuncional: [''],
      nomeTipoRelatorio: [''],
      itemContratual: [''],
      prazoInicio: [''],
      prazoFim: [''],
      periodoReferenciaInicio: [''],
      periodoReferenciaFim: [''],
    });
    this.buildCriteriosLabels();
  }
  private buildCriteriosLabels() {
    this.criteriosLabels = {
      nomeRelatorio: 'Nome do relatório',
      nomeAreaFuncional: 'Nome da área funcional',
      nomeTipoRelatorio: 'Tipo do Relatório',
      itemContratual: 'Item Contratual',
      prazoInicio: 'Prazo Início',
      prazoFim: 'Prazo Fim',
      periodoReferenciaInicio: 'Período de Referência Início',
      periodoReferenciaFim: 'Período de Referência Fim',
      situacaoPrazo: 'Situação prazo'
    };
  }
  // Requisição da aferição inicial
  getData(contractId: string, pageIndex: number = 0): void {
    this.relatoriosContratuaisService
      .getRelatorios(
        contractId,
        this.pageSize,
        pageIndex,
        this.sortState.sortDirection,
        this.sortState.sortProperty,
        this.filterText,
        this.filterData
      )
      .pipe(
        take(1),
        finalize(() => this.loadingService.hideLoading())
      )
      .subscribe({
        next: (res: any) => {
          const {
            content,
            pageSize,
            totalPages,
            totalElements,
            pageNumber
          } = res;

          this.dataSource.data = content;
          this.pageSize = pageSize;
          this.totalPages = totalPages;
          this.totalElements = totalElements;
          this.pageIndex = pageNumber;
        },
        error: (erro: any) => this.handleRequestError(erro)
      });
  }
  // === ORDENAÇÃO ===
  onSortChange(sortProperty: string): void {
    if (this.sortState.sortProperty === sortProperty) {
      this.sortState.sortDirection =
        this.sortState.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortState.sortProperty = sortProperty;
      this.sortState.sortDirection = 'asc';
    }

    // Requisição pode ser disparada aqui se necessário
    this.getData(this.contractId,0);
  }
  // === PAGINAÇÃO ===
  pageChangeEvent(event: PageEvent): void {
    const { pageIndex, pageSize } = event;

    if (this.pageSize !== pageSize) {
      this.pageSize = pageSize;
      this.pageSizeService.setPageSize(pageSize);
      this.getData(this.contractId,0);
      return;
    }

    if (this.pageIndex !== pageIndex) {
      this.getData(this.contractId,pageIndex);
    }
  }

  // === MODAL DE EXCLUSÃO ===
  openDialogDelete(event: any): void {
    const id = event;
    const item = this.dataSource.data.find(item => item.id === id);

    if (!item?.id) return;

    this.idRelatorio = item.id;

    this.dialog.open(ModalComponent, {
      data: {
        onPerformAction: this.onDeleteModalConfirm.bind(this),
        modalTitle: 'Excluir',
        modalContent: 'Você tem certeza que deseja excluir este relatório?'
      }
    });
  }

  // === CONFIRMAÇÃO DE EXCLUSÃO ===
  onDeleteModalConfirm(): void {
    this.relatoriosContratuaisService
      .deleteRelatorio(this.contractId, this.idRelatorio)
      .pipe(
        take(1),
        finalize(() => this.loadingService.hideLoading())
      )
      .subscribe({
        next: () => {
          this.openSnackBar('Relatório excluido com sucesso', 'sucess');
          this.getData(this.contractId, 0);
        },
        error: (erro: any) => this.handleRequestError(erro)
      });
  }
async openDialogForm(id: number, type: 'edit' | 'create'): Promise<void> {
  const isEdit = type === 'edit';
  const modal = await this.dialog.open(FormRelatorioComponent, {
      width: '820px',
      maxWidth: '90vw',
      data: isEdit ? { idRelatorio: id, idContract:this.contractId } : {idContract:this.contractId},
    });
   modal.afterClosed().subscribe(result => {
      if (result) {
     this.getData(this.contractId, 0);
      }
    });
 

}

  async openDialogHistorico(id: number) {
    const data = {
      type: 'relatorioContratual',
      id: id,
      contracId: this.contractId,
      fieldMappings: {
        observacao: 'Observação',
        itemContratual: 'Item Contratual',
        relatorio: 'Nome do Relatório',
        tipoRelatorio: 'Tipo de Relatório',
        areaFuncional: 'Área Funcional',
        tipoDataBase: 'Tipo de Data Base',
        dataBase: 'Data Base',
        prazo: 'Prazo',
        periodoReferenciaInicio: 'Período de Referência Início',
        periodoReferenciaFim: 'Período de Referência Fim',
        dataAfericao: 'Data da Aferição',
        statusAtual: 'Status atual da aferição'
      }
    };

    const modal = await this.modalCtrl.create({
      component: ModalHistoricComponent,
      componentProps: {
        data: data,
        fieldMappings: data.fieldMappings,
      },
    });

    modal.present();
  }

  // Tratamento centralizado de erros de requisição
  private handleRequestError(erro: any): void {
    if (erro.status !== 500 && erro.status) {
      this.openSnackBar(erro.error.message, 'error');
    } else if (erro.error?.error === 'Unprocessable Entity') {
      this.openSnackBar(erro.error.message, 'warning');
    } else {
      this.openSnackBar(
        'Sistema indisponível. Estamos trabalhando para resolver. Por favor, tente novamente mais tarde.',
        'error'
      );
    }
  }
  // === SNACKBAR DE ALERTA ===
  openSnackBar(description: string, type: string): void {
    const classMap: Record<string, string> = {
      sucess: 'snacbar-sucess',
      warning: 'snacbar-warning',
      error: 'snacbar-error'
    };

    const classSnack = classMap[type] || 'snacbar-default';

    this._snackBar.openFromComponent(AlertComponent, {
      duration: 3000,
      panelClass: [classSnack, 'snackbar-custom'],
      data: { description, type },
      horizontalPosition: 'center',
      verticalPosition: 'top'
    });
  }
async getActionCheckbox(event: any){
  let optionsSelected = event.data.data.filter((item:any) => item.selected);
  let idsRelatoriosSelecteds = optionsSelected.map((item:any) => item.id);
  const data = {
    idsRelatorios:idsRelatoriosSelecteds
  }
  this.dataAction = data;
  if(event.txt){
    
   const modal = await  this.dialog.open(ModalDeleteLotesComponent, {
      data: {
        title: 'Excluir Relatórios Operacionais',
        itemsToDelete: idsRelatoriosSelecteds.length
      }
    });
     this.actionDeleteLotes = 'null';
       modal.afterClosed().subscribe(result => {
      if (result) {
        this.deleteModalLotesConfirm();
      }else{
        this.actionDeleteLotes = 'cancelado';
      }
    });
  }
}

deleteModalLotesConfirm(){
      this.relatoriosContratuaisService.deleteRelatorioEmLote(this.contractId, this.dataAction).pipe(
        take(1),
        finalize(() => this.loadingService.hideLoading())
      )
      .subscribe({
        next: (data:any) => {

          if(data.message == 'Relatórios contratuais excluídos com sucesso.'){
            this.openSnackBar('Relatórios excluidos com sucesso', 'sucess');
             this.getData(this.contractId, 0);
             this.actionDeleteLotes = 'removido';
          }else{
          this.openSnackBar(data.message, 'warning');
          this.getData(this.contractId, 0);
          this.actionDeleteLotes = 'impedido';
          }
          
          this.dataAction = null;
        },
        error: (erro: any) => this.handleRequestError(erro)
      });
}



 openModalFilters(popover?: any) {
  
    let props;
    if(this.filterData ){
      props = this.filterData;
    }else{
      props = this.generatePropsFromForm(this.formRelatorioContratual);
    }
  
    const data = {
      type: 'relatorioContratual',
      propsRelatorioContratual: props
    };
  
    const dialogRef = this.dialog.open(ModalFiltersComponent, {
      panelClass: ['filter-panel'],
      data,
    });
  
    dialogRef.afterClosed().subscribe({
      next: (data: any) => {
        if (data) {
          // Atualiza os critérios com base nos dados do modal
          this.filterData = data;
          this.criterios = this.getCriterios(data);
          this.getData(this.contractId, 0);
        }
      }
    });
  }
  // Função para gerar o objeto props de forma dinâmica a partir dos valores do formulário
  private generatePropsFromForm(form: FormGroup): any {
    const props: any = {};
    // Itera sobre os controles do FormGroup
    Object.keys(form.controls).forEach((controlName: string) => {
      const control = form.get(controlName);
  
      // Verifica se o controle tem valor e não é nulo ou vazio
      if (control && control.value !== null && control.value !== undefined && control.value !== '') {
        props[controlName] = control.value;
      }
    });
    return props;
  }
  
  getCriterios(data: any) {
    const criterios = [];
  
    // Gera os critérios de forma dinâmica, verificando os valores dos campos
    const props: any = this.generatePropsFromForm(data);
  
    for (const prop in props) {
      if (props[prop] !== null && props[prop] !== undefined && props[prop] !== '') {
        criterios.push(prop);
      }
    }
  
    return criterios;
  }
  criterioRemoved(event:any){


    // Lógica para remover da lista de critérios, se necessário
    this.filterData.patchValue({
      [event.criterio]: null
    });
    this.criterios = this.criterios.filter((c:any) => c !== event.criterio);
    this.getData(this.contractId, 0);
  }
    applyFilter(filterValue: string) {
    this.filterText = filterValue;
    this.getData(this.contractId, 0);
  }
}
